// constants
import { managementZonesTypes } from 'constants/scripts';

// selectors
import {
  getActivityCategoriesByActivityType
} from 'activities/selectors';
import { getProductYearForScript } from 'scripts/selectors';
import { getActiveFieldId } from 'current/selectors';
import { getFertilityScriptsForFieldId } from 'scripts/fertility-selectors';

export const getFertilityManagementZones = (state) => {
  const scripts = getFertilityScriptsForFieldId(state, getActiveFieldId(state));
  if (Object.keys(scripts).length === 0) {
    return [];
  }
  const displayPrimaryScripts = Object.values(scripts);
  if (Object.keys(displayPrimaryScripts).length === 0) {
    return [];
  }
  const activitiesByType = getActivityCategoriesByActivityType(state);
  return displayPrimaryScripts.map((script) => {
    const productYear = getProductYearForScript(script);
    const { zones, id, 'update-time': lastUpdated, primary,
      'activity-type': type, 'activity-uuid': activityUuid } = script;
    return {
      id:  `${managementZonesTypes.FERTILITY}-${activityUuid}-${productYear}-${id}`,
      lastUpdated,
      primary,
      productYear,
      fertilityActivity: activitiesByType[type].code,
      managementZonesType: managementZonesTypes.FERTILITY,
      scriptId: id,
      zones
    };
  });
};
